import React from 'react';
import { Outlet } from 'react-router-dom';
import useCheckAccess from '@/shared/hooks/use-check-access';
import AccessDenied from '@/pages/access-denied';
import { UserAuthorityRole } from '@/shared/models/auth/auth-data';

interface ProtectedRouteProps {
  requiredRole: UserAuthorityRole;
  children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requiredRole, children }) => {
  const hasAccess = useCheckAccess(requiredRole);

  if (!hasAccess) {
    return <AccessDenied />;
  }

  return <>{children ? children : <Outlet />}</>;
};

export default ProtectedRoute;
